import { render, staticRenderFns } from "./products.vue?vue&type=template&id=6e6debbd&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports